import includes from 'lodash/includes'
import schema from '../../schema/editorSchema'
import { getNewQuestionTemplateAddMedia } from '../getNewQuestionTemplate'
import { getSoundDeliveryUrl, conformDeliveryUrl } from '../../../utils/mediaDeliveryUrls'
import { getActiveQuestionChoiceCount } from '../getActiveQuestionChoiceCount'
import { getActiveQuestionSlideWidth } from '../getActiveQuestionSlideWidth'
import tumblePodcastIds from '../../../staticData/tumblePodcastIds'
import analytics from '../../../utils/cdpAnalytics'

function sendInsertSoundAnalytics(soundAttrs, isQuestion, fromSoundLibrary, browseSoundLibraryCategory, searchSoundLibraryCategory) {
  const isTumblePodcast = includes(tumblePodcastIds, soundAttrs.fileId)
  analytics.track('Insert Sound', {
    isPromptMedia: isQuestion,
    title: soundAttrs.title,
    deliveryUrl: conformDeliveryUrl(soundAttrs.deliveryUrl),
    isClipped: soundAttrs.isClipped,
    source: soundAttrs.source,
    fromSoundLibrary: !!fromSoundLibrary,
    fullDuration: soundAttrs.fullDuration,
    clipDuration: soundAttrs.end - soundAttrs.start,
    fileId: soundAttrs.fileId,
    browseSoundLibraryCategory,
    searchSoundLibraryCategory,
    isTumblePodcast,
  })
}

export function insertSound(isUpload, fileId, soundTitle, soundDuration, clipStartTime, clipEndTime, insertPos, isQuestion, questionPos, questionNode, fromSoundLibrary, browseSoundLibraryCategory, searchSoundLibraryCategory) {
  let type
  const { tr } = window.view.state
  let newTemplate
  if (isQuestion) {
    newTemplate = getNewQuestionTemplateAddMedia(questionNode.attrs.template)// change template
    tr.setNodeMarkup(questionPos, null, { ...questionNode.attrs, template: newTemplate })
    type = schema.nodes.questionSound
  } else {
    type = schema.nodes.choiceSound
  }
  const start = clipStartTime || 0
  const end = clipEndTime || soundDuration
  let isClipped = false
  if (end - start !== soundDuration) {
    isClipped = true
  }
  const deliveryUrl = getSoundDeliveryUrl(fileId, start, end, isClipped, false)
  const nowDate = new Date()
  const source = isUpload ? 'upload' : 'mic'

  const soundAttrs = {
    fileId,
    deliveryUrl: conformDeliveryUrl(deliveryUrl),
    template: newTemplate,
    start,
    end,
    title: soundTitle,
    fullDuration: soundDuration,
    attribution: '',
    isClipped,
    source,
    addedAt: nowDate,
  }
  sendInsertSoundAnalytics(soundAttrs, isQuestion, fromSoundLibrary, browseSoundLibraryCategory, searchSoundLibraryCategory)

  if (isQuestion) {
    soundAttrs.questionMediaDynamicHeight = questionNode.attrs.questionMediaDynamicHeight
    soundAttrs.slideWidth = getActiveQuestionSlideWidth()
    window.view.state.doc.nodesBetween(questionPos, questionPos + questionNode.nodeSize, (node, pos) => {
      if (node.type.name === 'choiceImage' || node.type.name === 'choiceVideo' || node.type.name === 'choiceSound' || node.type.name === 'choice') {
        tr.setNodeMarkup(pos, null, { ...node.attrs, template: newTemplate })
      }
    })
  } else {
    soundAttrs.questionChoiceCount = getActiveQuestionChoiceCount()
    soundAttrs.slideWidth = getActiveQuestionSlideWidth()
  }

  const soundNode = type.create(soundAttrs)
  tr.replaceWith(insertPos.start, insertPos.end, soundNode)
  tr.setMeta('triggerParseDoc', true)
  window.view.dispatch(tr)
}
